<template>
  <div class="app-body" style="display: flex;width: calc(100% - 10px);">
    <div style="width:500px;flex:none;">
      <el-form ref="orderForm" class="query-form" :inline="true" :model="orderForm" label-width="100px">
        <el-form-item label="" label-width="0">
          <el-input v-model="orderForm.code" style="width: 400px;" :clearable="true" size="mini"
                    placeholder="请输入外销合同编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="$refs.orderTable.reload()">查询</el-button>
        </el-form-item>
      </el-form>
      <SweetTable url="/trade/agreement/page" api-version="v2" ref="orderTable" :query-form="orderForm"
                  @row-click="orderSelected" :after-table-binding="afterTableBinding">
        <el-table-column label="外销合同编号" prop="code"></el-table-column>
      </SweetTable>
    </div>
    <div style="flex:1;">
      <div class="product-list-box" v-for="(product,$index) in productList" :key="product.id">
        <div class="table-bar" style="margin-bottom: 0px;">
          <ProductRowCard :product="product"></ProductRowCard>
          <span style="margin-left: 20px;">发货数：{{ product.checkOutCount }}</span>
        </div>
        <SweetTable :data="product.bomList" :is-page="false" :id="'table'+$index" :summaries-column="['totalPrice']">
          <el-table-column label="品名" min-width="120" align="center" prop="name" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              label="颜色"
              prop="color"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="规格"
              prop="size"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="幅宽"
              prop="attr1"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="克重"
              prop="attr2"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="理论单耗"
              prop="count"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="实际单耗"
              prop="realCount"
              header-align="center"
              align="center"
              width="100"
          ></el-table-column>
          <el-table-column
              label="开票单价"
              prop="price"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="调整金额"
              prop="otherAmount"
              header-align="center"
              align="center"
              width="100"
          ></el-table-column>
          <el-table-column
              label="金额"
              prop="totalPrice"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
        </SweetTable>
      </div>
    </div>
  </div>
</template>

<script>
import ProductRowCard from '@/components/ProductRowCard.vue'
import BigNumber from 'bignumber.js'

export default {
  name: 'bom-settle',
  components: { ProductRowCard },
  data () {
    return {
      orderForm: {
        code: '',
      },
      productList: []
    }
  },
  activated () {
    this.$nextTick(() => {
      this.$refs.orderTable.reload()
    })
  },
  methods: {
    afterTableBinding (dataList) {
      if (this.$c.isArrayEmpty(dataList)) {
        this.$refs.orderTable.setCurrentRow(null)
        this.productList = []
      } else {
        this.$refs.orderTable.setCurrentRow(dataList[0])
        this.queryProductListWithBom(dataList[0].id)
      }
    },
    orderSelected (row) {
      this.queryProductListWithBom(row.id)
    },
    queryProductListWithBom (orderId) {

      this.productList = []
      this.$http.get(`/trade/agreement/detail/list`, {
        params: {
          agreementId: orderId,
          calculate: '1'
        }
      }).then(({ data: res }) => {
        this.beforeProductBinding(res.data)
        this.productList = res.data
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    beforeProductBinding (dataList) {
      if (!dataList || dataList.length == 0) {
        return
      }
      dataList.forEach((item, pi) => {
        if (!item.bomList) {
          item.bomList = []
        }

        item.hasBom = item.bomList.length > 0
        let tmpId = pi + 1
        item.bomList.push({
          id: tmpId++,
          name: '加工费',
          price: item.makeCost,
          count: 1,
          type: 'virtual'
        })
        item.bomList.push({
          id: tmpId++,
          name: '包装检品费',
          price: item.checkCost,
          count: 1,
          type: 'virtual'
        })
        item.bomList.push({
          id: tmpId++,
          name: '纸箱费',
          price: item.packCost||0,
          count: 1,
          type: 'virtual'
        })
        item.bomList.push({
          id: tmpId++,
          name: '中棉',
          price: item.cottonCost,
          count: 1,
          type: 'virtual'
        })

        //其他费用均摊
        if (item.otherCost) {
          item.otherCost = JSON.parse(item.otherCost)

          item.otherCost.forEach(cost => {
            item.bomList.push({
              id: cost.categoryName,
              name: cost.categoryName,
              price: cost.amount,
              count: 1,
              totalPrice: cost.amount,
              type: 'virtual'
            })
          })
        }
        item.bomList.forEach(bom => {
          let otherAmount = bom.otherAmount ? bom.otherAmount : 0
          if(!bom.realCount || bom.realCount == 0){
            bom.realCount = bom.count
          }
          let realCount = bom.realCount && bom.realCount > 0 ? bom.realCount : bom.count
          bom.totalPrice = new BigNumber(bom.price).multipliedBy(realCount).plus(otherAmount).toFixed(3)
          if (!bom.type) {
            bom.type = 'bom'
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list-box {
  margin: 10px;
  border: solid 1px #f1f4f5;

  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    margin: 10px;
  }
}
</style>
